import { Login } from '@/controllers/uiController'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import emitter, { EmitterEvents } from '@/helpers/emitter'
import { MobileLoginDecorator } from '@/helpers/decorator'
// import { envHelper } from '@/helpers/envHelper'
import { userService } from '@/services/userService'
import { action, computed, makeAutoObservable, observable } from 'mobx'
import { Dialog } from 'antd-mobile'
import { uiController } from '@/controllers/uiController'

export class GoodsDetailState {
  @observable
  detail?: ServerData.PptInfoData
  @observable
  materialId: number = 0

  @observable
  loading = true

  @observable
  downing = false

  @observable
  activeTab = 'preview'
  tabs = [
    // { label: '详情', key: 'detail' },
    { label: '预览', key: 'preview' },
  ] as const

  /** 是否可直接下载 */
  @computed
  get isDirectDownload() {
    return (
      this.detail?.downloadInfo?.hasSingleBuy === true ||
      (this.detail?.downloadInfo?.vipRemeDownloadCount ?? 0) > 0 ||
      (this.detail?.downloadInfo?.singleRemeDownloadCount ?? 0) > 0 ||
      this.detail?.planData?.price === 0
    )
  }

  /** 总下载次数 含兑换码下载次数 */
  @computed
  get allDownCount() {
    const { exchangeCodeRemeDownloadCount } = this.detail?.downloadInfo ?? {}
    return (exchangeCodeRemeDownloadCount ?? 0) + this.buyDonwCount
  }
  
  @computed
  get isSingleBuy() {
    return this.detail?.downloadInfo?.hasSingleBuy === true
  }
  /** 是否显示VIP按钮 */
  @computed
  get showOpenVipBtn() {
    return this.allDownCount === 0
  }

  /** 购买下载次数 */
  @computed
  get buyDonwCount() {
    const { vipRemeDownloadCount, singleRemeDownloadCount } = this.detail?.downloadInfo ?? {}
    return Math.max(0, vipRemeDownloadCount ?? 0) + Math.max(0, singleRemeDownloadCount ?? 0)
  }

  /** 是否显示下载按钮 */
  @computed
  get showDownloadBtn() {
    return (
      this.allDownCount > 0 ||
      this.detail?.downloadInfo?.hasSingleBuy === true
      ||this.detail?.planData?.price === 0
      //  ||
      // userService.isVip ||
      // this.detail?.planData?.price === 0
    )
  }

  constructor() {
    makeAutoObservable(this)
    emitter.on(EmitterEvents.PAY_SUCCESS, () => {
      this.getInfo(false)
    })
  }

  @action
  async getInfo(loading: boolean = true) {
    this.loading = loading
    const id = this.materialId
    const res = await api.ppt.getPptInfo(id)
    if (id !== this.materialId) {
      return
    }
    this.detail = res.data
    this.loading = false
  }

  @action
  async setMaterialId(materialId: number) {
    if (materialId !== this.materialId) {
      this.detail = undefined
    }
    this.materialId = materialId
    await this.getInfo()
  }

  @action
  async setActiveTab(activeTab: 'detail' | 'preview') {
    this.activeTab = activeTab
  }

  @Login()
  async download() {
    if (this.downing) {
      return
    }
    this.downing = true

    return api.ppt
      .getPptDownload(this.detail?.id ?? 0)
      .then((res) => {
        if (res.data?.url) {
          // const url = res.data.url
          // var downloadUrl =
          //   url + (url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment' // 补充强制下载的参数
          // downloadUrl += `;filename=${this.detail?.name}.${this.detail?.fileType}`
          // commonUtils.downloadFile(downloadUrl)
          if (commonUtils.isWechat()  && commonUtils.getOsType()==='Android'
          && res.data?.url?.indexOf('.zip') !== -1
          ) {
            // commonUtils.downloadFile(
            //   envHelper.webHost! +
            //     envHelper.apiBasePath! +
            //     '/material/download_file?url=' +
            //     encodeURIComponent(res.data.url)
            // )
            // 下载问题  安卓手机zip格式下载 系统会toast提示 可在浏览器里面下载，如果是ppt类格式 微信会引导用户进行跳转浏览器下载
            // 如果是安卓手机 弹出在浏览器里面下载  ios直接下载
            Dialog.confirm({
              title: '提示',
              content:
                '检测到您正在使用微信内置浏览器，可能导致下载失败或体验不佳，请前往浏览器中打开登录使用。',
              confirmText: '复制链接',
              cancelText: '取消',
              onConfirm: () => {
                commonUtils.copyToClipboard(
                  res.data.url)
                uiController.message.info('已复制链接，请前往浏览器中打开')
              },
            })
            // commonUtils.downloadFile(commonUtils.replaceDownloadUrl(res.data.url))
          } else {
            commonUtils.downloadFile(res.data.url)
          }
        }
      })
      .finally(() => {
        this.getInfo(false)
        setTimeout(() => {
          this.downing = false
        }, 500)
      })
  }


  @action
  @MobileLoginDecorator()
  async openVipModal(){
    return userService.isLogin

  }

}

const goodsDetailState = new GoodsDetailState()

export default goodsDetailState
